import { render } from "./PromotionManager.vue?vue&type=template&id=70c944bb&scoped=true"
import script from "./PromotionManager.vue?vue&type=script&lang=js"
export * from "./PromotionManager.vue?vue&type=script&lang=js"

import "./PromotionManager.vue?vue&type=style&index=0&id=70c944bb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c944bb"]])

export default __exports__